module.exports = __webpack_public_path__ + "static/section-2-d83bd5e955f8e23e3008eb50a1decba5.svg";